// extracted by mini-css-extract-plugin
export var component = "CoverLink-module--component--sHp4P";
export var label = "CoverLink-module--label--VQR4O";
export var current = "CoverLink-module--current--uXFxW";
export var inert = "CoverLink-module--inert--AAW5j";